import type {
  ExperienceConfiguration,
  Reference,
  VariantRef
} from '@ninetailed/experience.js-shared';
import type { MaybeRefOrGetter } from 'vue';
import { toValue, watchPostEffect } from 'vue';

type UseNinetailedComponentTrackingArgs = {
  element: MaybeRefOrGetter<Element | null | undefined>;
  enabled?: MaybeRefOrGetter<boolean>;
  experience?: MaybeRefOrGetter<
    ExperienceConfiguration<Reference | VariantRef> | null | undefined
  >;
  variant: MaybeRefOrGetter<Reference | VariantRef>;
  variantIndex: MaybeRefOrGetter<number>;
};

export function useNinetailedComponentTracking({
  element,
  enabled = true,
  experience,
  variant,
  variantIndex
}: UseNinetailedComponentTrackingArgs): void {
  const { $ninetailed } = useNuxtApp();

  watchPostEffect((onCleanup) => {
    const ninetailed = $ninetailed.value;
    if (!toValue(enabled) || !ninetailed) {
      return;
    }

    const rootElement = toValue(element);
    const currentVariant = toValue(variant);
    const currentVariantIndex = toValue(variantIndex);
    const currentExperience = toValue(experience);

    if (!rootElement) {
      return;
    }

    void currentVariant.id;
    void currentExperience?.id;

    ninetailed.observeElement(
      {
        componentType: 'Entry',
        element: rootElement,
        experience: currentExperience ?? null,
        audience: currentExperience?.audience,
        variant:
          'hidden' in currentVariant && currentVariant.hidden
            ? { ...currentVariant, id: `${currentVariant.id}-hidden` }
            : currentVariant,
        variantIndex: currentVariantIndex
      },
      {
        trackClicks: true,
        trackHovers: true
      }
    );

    onCleanup(() => {
      ninetailed.unobserveElement(rootElement);
    });
  });
}
